const fadeInSelector = '.section-fade-in';
const visibleClass = 'visible';
const observedElements = new WeakSet();
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

const revealElement = (element) => {
  element.getBoundingClientRect();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      element.classList.add(visibleClass);
    });
  });
};

const revealImmediately = () => {
  document.querySelectorAll(fadeInSelector).forEach(revealElement);
};

if (!('IntersectionObserver' in window) || reducedMotionQuery.matches) {
  revealImmediately();
} else {
  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealElement(entry.target);
        intersectionObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    }
  );

  const observeElement = (element) => {
    if (!(element instanceof HTMLElement)) return;
    if (!element.matches(fadeInSelector)) return;
    if (element.classList.contains(visibleClass)) return;
    if (observedElements.has(element)) return;

    observedElements.add(element);
    intersectionObserver.observe(element);
  };

  const observeTree = (root) => {
    if (!(root instanceof Element)) return;

    observeElement(root);
    root.querySelectorAll(fadeInSelector).forEach(observeElement);
  };

  observeTree(document.body);

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        observeElement(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(observeTree);
    });
  });

  mutationObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });

  reducedMotionQuery.addEventListener('change', (event) => {
    if (!event.matches) return;

    intersectionObserver.disconnect();
    mutationObserver.disconnect();
    revealImmediately();
  });
}
